// extracted by mini-css-extract-plugin
module.exports = {"confirmButton":"regulation_confirmButton__3Xhvx","formContent":"regulation_formContent__3pKsP","regulationContent":"regulation_regulationContent__1s6NH"};